"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const action_type_1 = __importDefault(require("../const/action-type"));
const initial_1 = __importDefault(require("../store/initial"));
//
exports.default = (state = initial_1.default.workspaceEvents, action) => {
    switch (action.type) {
        case action_type_1.default.SET_WORKSPACE_EVENTS:
            return action.data;
        case action_type_1.default.RESET_STORE:
            return initial_1.default.workspaceEvents;
        case action_type_1.default.SWITCH_WORKSPACE:
            return initial_1.default.workspaceEvents;
        default:
            return state;
    }
};
